import { Suspense, useEffect, lazy } from 'react'
import { createBrowserRouter, useNavigate } from 'react-router-dom'
import { LINKS } from './v1/utils/links.js';
// import SALStatement from './v1/pages/sal/sal-cash-flow/index.jsx';


// Lazy load all route-based components
const DefaultLayout = lazy(() => import("./v1/layout/DefaultLayout.js"));
const UnauthorizeError = lazy(() => import('./v1/pages/unauthorize/UnauthorizeError.jsx'));
const Login = lazy(() => import('./v1/pages/auth/Login.js'));
const Profile = lazy(() => import('./v1/pages/Profile/Profile'));
const Report = lazy(() => import('./v1/pages/Report/Report.jsx'));
const TBLibrary = lazy(() => import('./v1/pages/Tb-Library/TBLibrary.jsx'));
const AutohrizeRole = lazy(() => import('./v1/components/protectRoute/RoleBasedAutorization.js'));
const ChangePassword = lazy(() => import('./v1/pages/auth/ChangePassword.js'));
const ForgotPassword = lazy(() => import('./v1/SendingEmail/ForgotPassword'));
const ChangePasswordFirstLogin = lazy(() => import('./v1/SendingEmail/changePassword'));
const ResetPassword = lazy(() => import('./v1/SendingEmail/sendEmail'));
const CheckEmailReset = lazy(() => import('./v1/SendingEmail/CheckEmailReset'));


//v1 imports
const TitleAndToc = lazy(() => import('./v1/pages/titleAndToc/TitleAndToc.js'));
const Checks = lazy(() => import('./v1/pages/checks/Checks.jsx'));
const Analytics = lazy(() => import('./v1/pages/Analytics/Analytics.jsx'));
const NotesNew = lazy(() => import('./v1/pages/notes/NotesNew'));
const NotesAi = lazy(() => import('./v1/pages/notes/NotesAi'));
const CFSGroupingLibrary = lazy(() => import('./v1/pages/cfs/cfs-grouping-library/NewCFSGroupLibrary.jsx'));
const SESGroupingLibrary = lazy(() => import('./v1/pages/ses/ses-grouping-library/NewSESGroupLibrary.jsx'));
const SESWorksheet = lazy(() => import('./v1/pages/ses/SESWorksheet.jsx'));
// const UploadTB = lazy(() => import('./v1/pages/upload/UploadTB.jsx'));
const Schedule = lazy(() => import('./v1/pages/schedule/Schedule.jsx'));
const ViewTrialBalance = lazy(() => import('./v1/pages/viewTb/TrialBalance.jsx'));
const StockHoldersEquityStatement = lazy(() => import('./v1/pages/stockHoldersEquity/StockHoldersEquityStatement.jsx'));
const IncomeStatements = lazy(() => import('./v1/pages/incomeStatement/IncomeStatement.jsx'));
const BalanceSheetReport = lazy(() => import('./v1/pages/balanceSheet/BalanceSheet.jsx'));
const CFSWorkpaper = lazy(() => import('./v1/pages/cfs/CFSWorksheet.jsx'))
// const SFP_STATEMENTS= lazy(() => import('./v1/pages/sfp'))
const UploadCoaGl = lazy(() => import('./v1/pages/upload/UploadCoaGl.jsx'))
// const UploadCoaGl = lazy(() => import('./v1/pages/newUploadPage/UploadCoaGl.jsx'))
const SFP_STATEMENTS = lazy(() => import('./v1/pages/sfp/sfp-statements'))
const SFP_ACTIVITIES = lazy(() => import('./v1/pages/sfp/sfp-activities'))
const SFP_CASH_FLOW = lazy(() => import('./v1/pages/sfp/sfp-cash-flow'))
const SFP_EXPENSES = lazy(() => import('./v1/pages/sfp/sfp-expenses'))
const SFP_CHECKS = lazy(() => import('./v1/pages/sfp/sfp-checks'))
const SFP_FOOTNOTES = lazy(() => import('./v1/pages/sfp/sfp-footnotes'))
const SFP_DISCLOSURE_CHECKLIST = lazy(() => import('./v1/pages/sfp/sfp-footnotes/components/DisclosureChecklist'))

const SAL_STATEMENTS = lazy(() => import('./v1/pages/sal/sal-statements'))
const SAL_INVESTMENTS = lazy(() => import('./v1/pages/sal/sal-investments'))
const SAL_OPERATIONS = lazy(() => import('./v1/pages/sal/sal-operations'))
const SAL_PARTNER_CAPITAL = lazy(() => import('./v1/pages/sal/sal-partner-capital'))
const SAL_CASH_FLOW = lazy(() => import('./v1/pages/sal/sal-cash-flow'))
const SAL_CHECKS = lazy(() => import('./v1/pages/sal/sal-checks'))
const SAL_WORKPAPER = lazy(() => import('./v1/pages/sal/sal-workpaper'))
const SAL_FOOTNOTES = lazy(() => import('./v1/pages/sal/sal-footnotes'))
const SAL_DISCLOSURE_CHECKLIST = lazy(() => import('./v1/pages/sal/sal-footnotes/components/DisclosureChecklist'))

const EB_NAAB = lazy(() => import('./v1/pages/eb/eb-naab'))
const EB_CNAAB = lazy(() => import('./v1/pages/eb/eb-cnaab'))
const EB_SCHEDULE = lazy(() => import('./v1/pages/eb/eb-schedule'))
const EB_5500 = lazy(() => import('./v1/pages/eb/eb-5500'))
const EB_CHECKS = lazy(() => import('./v1/pages/eb/eb-checks'))
const EB_FOOTNOTES = lazy(() => import('./v1/pages/eb/eb-footnotes'))
const EB_DISCLOSURE_CHECKLIST = lazy(() => import('./v1/pages/eb/eb-footnotes/components/DisclosureChecklist'))

const CON_BS = lazy(() => import('./v1/pages/construction/con-balance-sheet'))
const CON_IS = lazy(() => import('./v1/pages/construction/con-income-statement'))
const CON_SES = lazy(() => import('./v1/pages/construction/con-stockholders-equity'))
const CON_CFS = lazy(() => import('./v1/pages/construction/con-cash-flow'))
const CON_CHECKS = lazy(() => import('./v1/pages/construction/con-checks'))
const CON_FOOTNOTES = lazy(() => import('./v1/pages/construction/con-footnotes'))
const CON_DISCLOSURE_CHECKLIST = lazy(() => import('./v1/pages/construction/con-footnotes/components/DisclosureChecklist'))
const CON_WIP = lazy(() => import('./v1/pages/construction/con-wip'))

// const GeneralLedger = lazy(() => import('./v1/pages/GeneralLedger/GeneralLedger.jsx'))

// Error Boundaries
const ReportsErrorBoundary = lazy(() => import('./v1/components/hoc/ReportsErrorBoundary.jsx'));
const CFSIndirect = lazy(() => import('./v1/pages/cfs/CFSIndirect.jsx'));
const CFSDirect = lazy(() => import('./v1/pages/cfs/CFSDirect.jsx'));
const MainGrouping = lazy(() => import('./v1/pages/Grouping/MainGrouping.jsx'));
const FeedbackForm = lazy(() => import('./v1/pages/feedback/FeedbackForm.jsx'));
const FeedbackReport = lazy(() => import('./v1/pages/feedback/FeedbackReport.jsx'));


/* Error logs page */
const LogsError = lazy(() => import('./v1/pages/logs/logs.jsx'));



const Redirect = ({ path }) => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(path);
    }, [navigate]);

    return null;
};

const withSuspense = (Component) => (
    <Suspense
        fallback={
            <div className="w-full h-screen flex items-center justify-center ">
            </div>
        }
    >
        {Component}
    </Suspense>
);

const router = createBrowserRouter([
    {
        path: '/',
        element: withSuspense(<DefaultLayout />),
        children: [
            {
                path: '/',
                element: withSuspense(<Redirect path="/Form" />),
            },
            {
                path: LINKS.CHANGE_PASSWORD,
                element: withSuspense(<ChangePassword />),
            },
            {
                path: LINKS.GROUP,
                element: withSuspense(<MainGrouping />),
            },
            {
                path: LINKS.SCHEDULES,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <Schedule />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.IS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <IncomeStatements />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.UPLOAD,
                element: withSuspense(<UploadCoaGl />),
            },
            // {
            //     path: '/uploadCoaGl',
            //     element: withSuspense(<UploadCoaGl />)
            // },
            {
                path: LINKS.TB,
                element: withSuspense(<ViewTrialBalance />),
            },
            {
                path: LINKS.BS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <BalanceSheetReport />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.TITLE_TOC,
                element: withSuspense(<TitleAndToc />),
            },
            {
                path: LINKS.STOCKHOLDER,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <StockHoldersEquityStatement />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.NOTES,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <NotesNew />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.NOTES_AI,
                element: withSuspense(<NotesAi />),
            },
            {
                path: LINKS.CHECKS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <Checks />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.ANALYTICS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <Analytics />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.CFS_WORKSHEET,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <CFSWorkpaper />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SES_WORKSHEET,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SESWorksheet />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: 'cfsv1',
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <CFSWorkpaper />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.CFS_INDIRECT,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <CFSIndirect />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SFP_STATEMENTS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SFP_STATEMENTS />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SFP_ACTIVITIES,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SFP_ACTIVITIES />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SFP_CASH_FLOW,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SFP_CASH_FLOW />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SFP_EXPENSES,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SFP_EXPENSES />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SFP_CHECKS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SFP_CHECKS />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SFP_FOOTNOTES,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SFP_FOOTNOTES />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SFP_DISCLOSURE_CHECKLIST,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SFP_DISCLOSURE_CHECKLIST />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.CON_BS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <CON_BS />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.CON_IS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <CON_IS />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.CON_SES,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <CON_SES />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.CON_CFS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <CON_CFS />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.CON_CHECKS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <CON_CHECKS />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.CON_FOOTNOTES,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <CON_FOOTNOTES />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.CON_DISCLOSURE_CHECKLIST,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <CON_DISCLOSURE_CHECKLIST />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.CON_WIP,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <CON_WIP />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SAL_STATEMENTS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SAL_STATEMENTS />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SAL_INVESTMENTS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SAL_INVESTMENTS />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SAL_OPERATIONS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SAL_OPERATIONS />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SAL_PARTNER_CAPITAL,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SAL_PARTNER_CAPITAL />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SAL_CASH_FLOW,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SAL_CASH_FLOW />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SAL_CHECKS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SAL_CHECKS />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SAL_WORKPAPER,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SAL_WORKPAPER />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SAL_FOOTNOTES,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SAL_FOOTNOTES />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.SAL_DISCLOSURE_CHECKLIST,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <SAL_DISCLOSURE_CHECKLIST />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.EB_NAAB,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <EB_NAAB />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.EB_CNAAB,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <EB_CNAAB />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.EB_SCHEDULE,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <EB_SCHEDULE />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.EB_5500,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <EB_5500 />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.EB_CHECKS,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <EB_CHECKS />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.EB_FOOTNOTES,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <EB_FOOTNOTES />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.EB_DISCLOSURE_CHECKLIST,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <EB_DISCLOSURE_CHECKLIST />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.CFS_DIRECT,
                element: withSuspense(
                    <ReportsErrorBoundary>
                        <CFSDirect />
                    </ReportsErrorBoundary>
                ),
            },
            {
                path: LINKS.REPORT,
                element: withSuspense(
                    <AutohrizeRole roles={['SUPERADMIN']}>
                        <Report />
                    </AutohrizeRole>
                ),
            },
            {
                path: LINKS.PROFILE,
                element: withSuspense(
                    <AutohrizeRole roles={['SUPERADMIN', 'CUSTOMERADMIN']}>
                        <Profile />
                    </AutohrizeRole>
                ),
            },
            {
                path: LINKS.CFS_GROUPING_LIBRARY,
                element: withSuspense(
                    <AutohrizeRole roles={['SUPERADMIN']}>
                        <CFSGroupingLibrary />
                    </AutohrizeRole>
                ),
            },
            {
                path: LINKS.SES_GROUPING_LIBRARY,
                element: withSuspense(
                    <AutohrizeRole roles={['SUPERADMIN']}>
                        <SESGroupingLibrary />
                    </AutohrizeRole>
                ),
            },
            {
                path: LINKS.TB_LIBRARY,
                element: withSuspense(
                    <AutohrizeRole roles={['SUPERADMIN']}>
                        <TBLibrary />
                    </AutohrizeRole>
                ),
            },
            {
                path: LINKS.FEEDBACK_FORM,
                element: withSuspense(<FeedbackForm />),
            },
            // {
            //     path: LINKS.GENERAL_LEDGER,
            //     element: withSuspense(<GeneralLedger />),
            // },
            {
                path: LINKS.FEEDBACK_REPORT,
                element: withSuspense(
                    <AutohrizeRole roles={['SUPERADMIN']}>
                        <FeedbackReport />
                    </AutohrizeRole>
                ),
            },
            {
                path: LINKS.Layer_Error,
                  element: withSuspense(
                    <AutohrizeRole roles={['SUPERADMIN']}>
                        <LogsError />
                    </AutohrizeRole>
                ),
            },
        ]
    },
    {
        path: LINKS.SIGNIN,
        element: <Login />,
    },
    {
        path: LINKS.RESET_PASS,
        element: <ResetPassword />
    },
    {
        path: LINKS.RESET_EMAIL,
        element: <CheckEmailReset />
    },
    {
        path: LINKS.FORGOT_PASS_TOKEN,
        element: <ForgotPassword />
    },
    {
        path: LINKS.CHANGE_PASS_TOKEN,
        element: <ChangePasswordFirstLogin />
    },
    {
        path: LINKS.UNAUTHORIZEERROR,
        element: <UnauthorizeError />
    }
])

export default router;